// extracted by mini-css-extract-plugin
export default {"card":"CardItem_card__1k7Rk","top":"CardItem_top__wh6Pt","overlay":"CardItem_overlay__7jRld","footer":"CardItem_footer__AdsSQ"};